import { Col, Modal, Radio, Row } from "antd";
import React from "react";
import "./style.scss";

const ProductGiftsModal = (props: any) => {
  const { visible, promotion, handleClose, handleChange } = props;
  // const { innerWidth } = window;
  const changeValue = (value: any) => {
    const newOpt = promotion?.options?.filter(
      (p: any) => p.spec_id === value.target.value
    )[0];

    handleChange(promotion.feature_id, newOpt);
  };

  const showOptions = (otpions: any) => {
    const _options =
      otpions && otpions.length
        ? otpions.filter((o: any) => o.is_out_stock !== true)
        : [];

    if (!_options.length) {
      return (
        <span className="main-content all-out-stock-title">
          Hiện tại tạm hết tất cả mẫu hoa văn!
        </span>
      );
    }

    return (
      <Radio.Group
        onChange={changeValue}
        value={promotion.default_prop}
        className="kd-options-gift-wrap">
        {_options.map((g: any, i: number) => (
          <Radio.Button key={i} value={g.spec_id}>
            <Row justify="space-between" align="middle">
              <Col className="img-wrap">
                <img src={g.img} />
              </Col>
              <Col className="name-title">{g.name}</Col>
            </Row>
          </Radio.Button>
        ))}
        ;
      </Radio.Group>
    );
  };

  return (
    <Modal
      title=""
      onCancel={handleClose}
      visible={visible}
      // visible={true}
      footer={null}
      // width={innerWidth >= WIDTH_MOBILE ? 489 : "auto"}
      // centered
      className="kd-gifts-modal">
      <Row className="title-modal-wrap">
        <Col span={24}>
          <span>
            Quý khách vui lòng chọn Hoa văn cho Ga trải giường được tặng theo
            chương trình khuyến mãi:
          </span>
        </Col>
      </Row>
      {showOptions(promotion.options)}
    </Modal>
  );
};

export default ProductGiftsModal;
